import React from 'react'

export const Notificaciones = () => {
  return (
    <div className='fade-in-2'>Notificaciones</div>
  )
}
